/* eslint-disable no-empty */
/* eslint-disable react/prop-types */
import * as React from 'react';
import './MajorSelectedSearch.scss';
import {Context} from '../../../../../context/dataStore';

const MajorSelectedSearch = props => {
  const {searchData, actionDataSentBack, setPage} = props;
  const {state: {selSearchVal}, dispatch} = React.useContext(Context);

  const [autoData, setAutoData] = React.useState([]);

  React.useEffect(() => {
    let isCurrent = true;
    if(isCurrent){
      setAutoData(searchData);
    }
    return() => isCurrent = false;
  }, [searchData]);

  React.useEffect(()=>{
    let isCurrent = true;
    if(isCurrent){
      setPage(1);
    }
    setPage(1);
    return() => isCurrent = false;
  }, [setPage]);

  const clearInput = () => {
    dispatch({type:'SEL_SEARCH_VAL',payload:''});
    actionDataSentBack(searchData);
  };
  const onSubmitSearch = entry => {
    if (entry.length > 1) {
      const parent = document.getElementById('dynamic_data');
      while (parent.firstChild && !parent.firstChild.remove()) { }
    }
    autoData.forEach(({name, qid}) => {

      //name: 26.1199-math , entry : 26./1199/math
      const comparearr = name.split('-');
      const cipcode = comparearr[0].trim();
      const majorname = comparearr[1].trim();
      if ((majorname.slice(0, 3).toLowerCase() === entry.toLowerCase())||(
        cipcode.slice(0,3).toLowerCase() === entry.toLowerCase()
      )) {
        const option = document.createElement('option');
        option.value = name;
        option.id = qid;
        (document.getElementById('dynamic_data')).appendChild(option);
      }
    });
  };

  /**
   * this is used to update the callback that is used to update the table
   */
  const alterTableData = data => {
    if(data.length > 2) {
      if(data !== '') {
        const findData = searchData.filter(el => (el.name).toLowerCase().includes(data.toLowerCase()));
        actionDataSentBack(findData);
      } else {
        actionDataSentBack(searchData);
      }
    }
    if(data.length === 0) {
      actionDataSentBack(searchData);
    }
  };

  return (
    <div className='flex_container_col cb-input'>
      <input
        autoComplete='off'
        id='selectedMajorInput'
        type='text'
        list='dynamic_data'
        placeholder='Search by keyword or CIP Code'
        aria-label='data look up'
        data-testid='datalookuptestid'
        value={selSearchVal}
        onChangeCapture={event => {
          const val = event.target.value;
          dispatch({type:'SEL_SEARCH_VAL',payload:val});
          alterTableData(val);
        }}
        onChange={event => {
          const val = event.target.value;
          onSubmitSearch(val);
        }}
      />
      <i className='cb-icon cb-search' aria-hidden='true' id='selectedSearchIcon' />
      <i className='cb-icon cb-x-mark' aria-hidden='true' id='selectedCloseX' onClick={() => clearInput()} />
      <datalist id='dynamic_data' />
    </div>
  );
};

export default MajorSelectedSearch;